import { createLazyFileRoute } from "@tanstack/react-router";

import { AdBlock } from "@/blocks/AdBlock.tsx";
import { ProjectionsBlock } from "@/blocks/ProjectionsBlock.tsx";
import { RidingSelectorBlock } from "@/blocks/RidingSelectorBlock.tsx";
import { SvDonationBlock } from "@/components";

const Election = () => {
  const { election } = Route.useParams();

  return (
    <>
      <RidingSelectorBlock election={election} />
      <AdBlock />
      <ProjectionsBlock election={election} className="bg-white" />
      <SvDonationBlock />
    </>
  );
};

export const Route = createLazyFileRoute("/ridings/$election")({
  component: Election,
});
